    <template>
    <nav class="steps_navigator-container"
    :class="{graph_mode : getActiveStep === 4}">
        <div class="element" @click="changeStep(1)">
            <img v-if="getSelectedFirstStepElement.imgSrc"
                 :src="'data:image/png;base64, ' + getSelectedFirstStepElement.imgSrc" alt="fan">
            <span v-else class="icon-thin_one"/>
            <div v-if="getSelectedFirstStepElement.name" class="wrapper">
                <div class="name-container">
                    <span class="text">{{translate("fan_type")}}</span>
                    <span class="name">{{translate(getSelectedFirstStepElement.name)}}</span>
                    <div class="rectangle"></div>
                </div>
            </div>
        </div>
        <span class="icon-right_arrow separator"/>
        <div class="element" @click="changeStep(2)" v-if="getSelectedSecondStepElement.imgSrc">
            <img v-if="getSelectedSecondStepElement.imgSrc"
                    :src="'data:image/svg+xml;base64, ' + getSelectedSecondStepElement.imgSrc" alt="mode_image">
<!--            <span v-else class="icon-thin_two"></span>-->
            <div v-if="getSelectedSecondStepElementName" class="wrapper">
                <div class="name-container">
                    <span class="text">{{translate("fan_sort")}}</span>
                    <span class="name">{{translate(getSelectedSecondStepElementName)}}</span>
                    <div class="rectangle"></div>
                </div>
            </div>
        </div>
        <span class="icon-right_arrow separator" v-if="getSelectedSecondStepElement.imgSrc"/>
        <div class="element img-step" @click="changeStep(3)" v-if="getSelectedThirdStepElement.imgSrc">
            <img class="full-img" v-if="getSelectedThirdStepElement.imgSrc"
                    :src="'data:image/png;base64, ' + getSelectedThirdStepElement.imgSrc" alt="material_image">
<!--            <span v-else class="icon-thin_three"></span>-->
            <div v-if="getSelectedThirdStepElementName" class="wrapper">
                <div class="name-container">
                    <span class="text">{{translate("material_sort")}}</span>
                    <span class="name">{{translate(getSelectedThirdStepElementName)}}</span>
                    <div class="rectangle"></div>
                </div>
            </div>
        </div>
        <span class="icon-right_arrow separator" v-if="getSelectedThirdStepElement.imgSrc"/>
        <div class="element" @click="changeStep(4)">
            <span class="icon-thin_ok"
                  :class="{selected : getActiveStep === 4}"/>
        </div>
    </nav>
</template>

<script>
    export default {
        name: "StepsNavigator",
        data() {
            return {
                isZindex: false
            }
        },
        methods: {

            changeStep(step) {

                this.$store.commit({
                    type: 'changeActiveConfigurationStep',
                    step: step
                });

                this.$store.commit('resetOfferState');
            },
            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                };

                this.$store.commit(arg);

                return arg.out;

            },
        },

        computed: {
            getActiveStep() {
                return this.$store.state.activeConfigurationStep;
            },

            getSelectedFirstStepElement() {
                return this.$store.state.selectedFirstStepElement;
            },

            getSelectedSecondStepElement() {
                return this.$store.state.selectedSecondStepElement;
            },

            getSelectedThirdStepElement() {
                return this.$store.state.selectedThirdStepElement;
            },

            getSecondStepElements() {
                return this.$store.state.secondStepElements;
            },

            getSelectedSecondStepElementName() {
                return this.$store.state.selectedSecondStepElement.name;
            },

            getSelectedThirdStepElementName() {
                return this.$store.state.selectedThirdStepElement.name;
            }
        }
    }
</script>